module.exports = __webpack_public_path__ + "img/close.2575acf5.svg";